// Tab functionality
document.addEventListener('DOMContentLoaded', function () {
  const select = document.getElementById('calc_type');

  function updateTabDisplay() {
    const selectedOption = select.options[select.selectedIndex];
    const selectedTab = selectedOption.getAttribute("data-name");

    const tabs = document.querySelectorAll('.calculator_selectorCont .calcContent');
    tabs.forEach(function (tab) {
      tab.style.display = (tab.id === selectedTab) ? 'block' : 'none';
    });
  }

  updateTabDisplay(); // Show default tab on load
  select.addEventListener('change', updateTabDisplay); // Update on change
});
// Tab functionality

// BMI Calculator
function limitFeet(input) {
  // Allow only 1 digit (0–9)
  input.value = input.value.replace(/[^0-9]/g, '').slice(0, 1);
}
function limitInches(input) {
  // Allow only 2 digits 
  input.value = input.value.replace(/[^0-9]/g, '').slice(0, 2);

  // If value is more than 11, clamp to 11
  if (parseInt(input.value) > 11) {
    input.value = 11;
  }
}

function calculateBMI() {
  const feet = parseFloat(document.getElementById("feets").value);
  const inches = parseFloat(document.getElementById("inches").value);
  const weight = parseFloat(document.getElementById("weight").value);
  const unit = document.getElementById("unit").value;

  let heightInInches = feet * 12 + inches;
  let weightInKg = unit === "kg" ? weight : weight * 0.453592;
  let heightInM = heightInInches * 0.0254;

  const bmi = weightInKg / (heightInM * heightInM);
  updateNeedle(bmi);
}

// function updateNeedle(bmi) {
//     // Clamp between 10 and 40 for meter range
//     const clampedBMI = Math.min(Math.max(bmi, 1), 40);
//     const angle = ((clampedBMI - 1) / (40 - 1)) * 180 - 90; // [-90 to +90]
//     document.getElementById("needle").setAttribute("transform", `rotate(${angle})`);
//     document.getElementById("bmiText").textContent = `BMI = ${bmi.toFixed(1)}`;
// }

function updateNeedle(bmii) {
  const minBMI = 0;
  const maxBMI = 40;
  const minAngle = -90;
  const maxAngle = 90;

  let angle;
  const bmi = bmii.toFixed(1);
  console.log('bmiFixed ',bmi);
  if (bmi < 1) {
    // Interpolate from 0–17 -> -90° to -61.27000045776368°
    angle = -90;
  } else if (bmi < 17) {
    // Interpolate from 0–17 -> -90° to -61.27000045776368°
    angle = -90 + (bmi / 17) * 29;
  } else if (bmi <= 18) {
    // 17.1–18 -> -58.32899856567383° to -35.36°
    angle = -58.32899856567383 + ((bmi - 17.1) / 0.9) * 25.717998504638672;
  } else if (bmi <= 25) {
    // 18.1–25 -> -50° to -3.009999990463257°
    // angle = -50 + ((bmi - 18.1) / 6.9) * 50;
    angle = -30.465999603271488 + ((bmi - 18.1) / 6.9) * 26.16900000000004;
  } else if (bmi <= 30) {
    // 25.1–30 -> 0° to 30°
    angle = -1.840000033378601 + ((bmi - 25.1) / 4.9) * 27.8400000333786;
    console.log('angle 30',angle);
  } else if (bmi <= 31) {
    // 30.1–31 -> 30° to 40°
    angle = 28 + ((bmi - 30.1) / 0.9) * 17.99999999999999;
  } else if (bmi <= 35) {
    // 31.1–35 -> 40° to 60°
    angle = 47.875 + ((bmi - 31.1) / 3.9) * 12.375;
  } else if (bmi <= 40) {
    // 35.1–40 -> 60° to 90°
    angle = 62.7400016784668 + ((bmi - 35.1) / 4.9) * 27.2599983215332;
  } else {
    angle = 90; // Max cap
  }
  
  document.getElementById("needle").setAttribute("transform", `rotate(${angle})`);
  document.querySelector("#bmiText span").textContent = `${bmi}`;
  document.querySelector(".resultSubheading.bmi_result span").textContent = `${bmi}`;
}
// BMI Calculator




// Waist Circumference
document.getElementById("gender_type").addEventListener("change", function () {
  document.getElementById("gender").textContent = this.options[this.selectedIndex].text;
});

function calculateWaist() {
  const gender = document.getElementById("gender_type").value;
  const unit = document.getElementById("waist_unit").value;
  const waistInput = parseFloat(document.getElementById("waist").value);

  //console.log(`S: ${gender}; Unit: ${unit}; Input: ${waistInput}`);

  if (isNaN(waistInput)) return;

  // Determine min/max based on gender and unit
  let minRange = 0;
  let maxRange;

  if (gender === 'male') {
    maxRange = unit === 'waist_inches' ? 80 : 200;
  } else {
    maxRange = unit === 'waist_inches' ? 70 : 180;
  }

  // Clamp waist to [min, max] for needle calculation
  const clampedWaist = Math.max(minRange, Math.min(maxRange, waistInput));

  // Normalize and map to angle [-90 to +90]
  const ratio = (clampedWaist - minRange) / (maxRange - minRange);
  const angle = -90 + ratio * 180;

  // Update needle rotation
  document.getElementById("waist_needle").setAttribute("transform", `rotate(${angle})`);

  // Show the original input (rounded, with units)
  const displayedWaist = unit === 'waist_inches'
    ? `${Math.round(waistInput)} inches`
    : `${Math.round(waistInput)} cm`;

  document.getElementById("waistText").textContent = `Waist Circumference = ${displayedWaist}`;
  document.querySelector(".resultSubheading.waist_result span").textContent = `${displayedWaist}`;
}
// Waist Circumference
  
  
  